import { NOTIFICATION_BROADCAST_TYPE } from "@/entities/notification-broadcast";
import { useEventBusListener } from "@/modules/event-bus";

import { useInterventionActionTransition } from "./intervention-action-transition.hook";

export const InterventionActionTransition = () => {
  const { runAction } = useInterventionActionTransition();

  useEventBusListener(
    NOTIFICATION_BROADCAST_TYPE.INTERVENTION_TRANSITION,
    runAction
  );

  return <></>;
};
